import useClientConfig from "../hooks/clientConfigHook"
import { materializeValue } from "../utils/lazyValue";
import AddressInputAU, { toString as toStringAU } from "./AddressInput_AU"
import AddressInputIntl from "./AddressInput_Intl";
import AddressInputVU, { toString as toStringVU } from "./AddressInput_VU";
import { withComponentCapabilities } from "./capabilities/componentCapabilities";

export const toString = async ({ value, defaultValue, clientConfig, ...props }) => {
    value = await materializeValue(value);
    if (!value) {
        return defaultValue;
    }
    switch (clientConfig.address?.country) {
        case 'vu':
            return toStringVU({ value, defaultValue, clientConfig, ...props });
        case 'au':
        default:
            return toStringAU({ value, defaultValue, clientConfig, ...props });
    }
}

export const customCtrlDef = {
    toString,
    control: ({ def, value, onChange, ...props}) => {
        return <AddressInput address={value} onChange={(value, field) => onChange(field, value)} {...props}></AddressInput>
    }
}

/**
 * A generic address wrapper which can select a locale specific address based on the application configuration
 * @component
 */
const AddressInput = withComponentCapabilities(({...props}) => {
    const clientConfig = useClientConfig();
    switch (clientConfig.address?.country) {
        case 'vu':
            return <AddressInputVU {...props}></AddressInputVU>
        case 'intl':
            return <AddressInputIntl {...props}></AddressInputIntl>
        case 'au':
        default:
            return <AddressInputAU {...props}></AddressInputAU>
    }
}, {
    lazyProps: ['address']
});
export default AddressInput;